import { render, staticRenderFns } from "./VideoConferencingTool.vue?vue&type=template&id=6a97ee95&scoped=true"
import script from "./VideoConferencingTool.vue?vue&type=script&lang=js"
export * from "./VideoConferencingTool.vue?vue&type=script&lang=js"
import style0 from "./VideoConferencingTool.vue?vue&type=style&index=0&id=6a97ee95&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6a97ee95",
  null
  
)

export default component.exports